<template>
  <div></div>
</template>

<script>
import {api} from "./api/Login";
import bus from "../utils/bus";
import {errorMessage} from "../utils/errorCode";
import {errorHandler} from "../utils/errorHandler";

export default {
  name: "LoginFree",
  data () {
    return {
      yqCode: ''
    }
  },
  created() {
    this.yqCode = this.$route.params.id
    bus.global.yqCode = this.yqCode
    this.loginFree()
  },
  methods: {
    loginFree () {
      this.$axios.post(api.loginFree, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            window.sessionStorage.setItem('accountCode', res.data.data.code)
            window.sessionStorage.setItem('accountName', res.data.data.name)
            window.sessionStorage.setItem('accountPersonCode', data.personCode)
            window.sessionStorage.setItem('accountPersonName', data.personName)
            window.sessionStorage.setItem('token', res.data.data.token)
            window.sessionStorage.setItem('permissionCodes', res.data.data.permissionCodes)
            window.sessionStorage.setItem('yqCode', this.yqCode)
            bus.global.accountCode = res.data.data.code
            bus.global.accountName = res.data.data.name
            bus.global.personCode = data.personCode
            bus.global.personName = data.personName
            bus.global.token = res.data.data.token
            bus.global.yqCode = this.yqCode
            bus.global.permissionCodes = res.data.data.permissionCodes
            this.toHomepage()
          }
        })
        .catch(errorHandler('登录失败'))
    },

    toHomepage () {
      window.sessionStorage.setItem('navTop', 'workbench')
      this.$router.push({
        name: 'workbench'
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/LoginFree.vue